import { render } from "./TvmLoaderModal.vue?vue&type=template&id=a846010c"
import script from "./TvmLoaderModal.vue?vue&type=script&lang=js"
export * from "./TvmLoaderModal.vue?vue&type=script&lang=js"

import "./TvmLoaderModal.vue?vue&type=style&index=0&id=a846010c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__